module.exports = __webpack_public_path__ + "static/media/4-wap.1ef6e2f9.png";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/pageUrlSec/4-wap.png
// module id = 582
// module chunks = 0